import { render, staticRenderFns } from "./BindJobNumber.vue?vue&type=template&id=b8c2c530&scoped=true"
import script from "./BindJobNumber.vue?vue&type=script&lang=js"
export * from "./BindJobNumber.vue?vue&type=script&lang=js"
import style0 from "./BindJobNumber.vue?vue&type=style&index=0&id=b8c2c530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c2c530",
  null
  
)

export default component.exports